import {createAction, PayloadAction} from '@reduxjs/toolkit';
import {Polygon} from 'geojson';
import {call, ForkEffect, put, takeLatest} from 'redux-saga/effects';

import {
  addProject,
  fail,
  requesting,
  success,
} from 'App/features/searchEntities/lightProjects/lightProjectsSlice';
import {TFullProject} from 'App/features/searchEntities/lightProjects/lightProjectsTypes';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as pageRequests from 'Pages/page/page_requests';

import * as log from '../../../../../logger';

type RequestCreateProjectPayload = {
  geometry: Polygon;
  page: string;
};

export const requestCreateProject = createAction(
  'lightProjects/requestCreateProject',
);

function* requestCreateProjectSaga({
  payload,
}: PayloadAction<RequestCreateProjectPayload>) {
  yield put(requesting());
  try {
    const fullProject: TFullProject = yield call(
      // Saga is not used yet and uses old api.
      // Rewrite this method when necessary
      pageRequests.createProjectInPage,
      payload.geometry,
      payload.page,
    );
    yield put(
      addProject({
        fullProject,
        geometry: payload.geometry,
      }),
    );
    yield put(success());
  } catch (error) {
    if (error instanceof Error) {
      yield call(log.exception, error);
    }
    yield put(fail({error: 'requestCreateProjectError'}));
  }
}

function* watchRequestCreateProject(): Generator<ForkEffect<void>, void> {
  yield takeLatest(requestCreateProject.type, requestCreateProjectSaga);
}

export default watchRequestCreateProject;
